import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { AktienTrends } from '../entities/boerse/aktientrends.entity';
import { Tageslinie } from '../entities/boerse/tageslinie.entity';
//#endregion

@Injectable()
export class TageslinieService extends ODataEntityService<Tageslinie> {
  constructor(protected client: ODataClient) {
    super(client, 'Tageslinie', 'entities.boerse.Tageslinie');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public aktienTrends(entity: EntityKey<Tageslinie>): ODataNavigationPropertyResource<AktienTrends> {
    return this.entity(entity).navigationProperty<AktienTrends>('aktienTrends');
  }
  //#endregion
}
